module.exports = __webpack_public_path__ + "static/img/user.4b69f684.png";